module.exports = __webpack_public_path__ + "static/media/FlagImgBig.a94a696f.png";